var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBdouinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6960",
    "data-name": "Group 6960",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 91.622,
    height: 82.525,
    viewBox: "0 0 91.622 82.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-bdouin-logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 91.622,
    height: 82.525,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5264",
    "data-name": "Group 5264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5263",
    "data-name": "Group 5263",
    clipPath: "url(#clip-path-bdouin-logo)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8930",
    "data-name": "Path 8930",
    d: "M124.928,23.4c-.466-4.231-3.678-7.916-8.86-8.945-1.61-5.968-8.543-10.475-16.852-10.442-9.651.039-14.877,3.779-16.576,8.983a10.047,10.047,0,0,0-3.018,3.4c-7.87.494-14.058,5.555-14.058,11.729a9.188,9.188,0,0,0,.3,2.311A3.924,3.924,0,0,0,64,33.477c0,2.974,4.745,5.384,10.6,5.384h.029a19.234,19.234,0,0,0,6.26,1.028,19.823,19.823,0,0,0,3.351-.286,26.948,26.948,0,0,0,12.092,2.635A28.024,28.024,0,0,0,107.1,40.218c.289.009.581.014.874.014a24.892,24.892,0,0,0,8.481-1.423,14.1,14.1,0,0,0,4.392.689c6.1,0,11.038-3.736,11.038-8.346,0-3.52-2.883-6.529-6.961-7.755",
    transform: "translate(-50.946 -3.192)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5266",
    "data-name": "Group 5266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5265",
    "data-name": "Group 5265",
    clipPath: "url(#clip-path-bdouin-logo)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8931",
    "data-name": "Path 8931",
    d: "M120.134,20.005c-1.028-8.174-6.535-9.325-8.762-9.4C99.821-7.455,81.367,3.02,81.367,3.02c-2.252,1.615-.93,1.517,1.083.661,15.941-5.926,25.374,5.02,27.16,7.024-2.056.1-5.556,2.57-4.911,3.178,9.885-6.209,13.675,3.647,13.673,5.926-1.468,0-3.573.563-3.965,1.517,6.51-2.2,13.559,2.4,10.23,9.741s-14.342,4.5-16.1,2.4c-.367-.2-1.077-.2.538,1.566a19.2,19.2,0,0,1-7.783.979c-13.461,4.65-20.118.783-22.565-.343a21.414,21.414,0,0,1-11.111-.832c.685-.294,1.86-1.077,1.762-1.958-1.713,1.811-4.5,1.468-5.629,1.273-8.566-1.517-4.454-6.021-3.28-7.2-.93-14,13.167-13.216,15.761-12.971a7.994,7.994,0,0,0-2.3-1.224A11.571,11.571,0,0,1,81.4,8.406a11.864,11.864,0,0,1,.258-1.176c-6.167,1.566-8.37,4.259-9.383,5.315-16.141.883-13.69,12.17-13.182,14.362-7.5,7.072,3.5,9.542,8.125,8.958,2.545,1.273,9.006,1.517,11.058,1.2,11.4,6.578,22.109,1.18,23.5.411,4.009.938,9.813-1.035,9.594-1.175,0,0,12.286,3.182,15.712-4.7s-4.356-11.307-6.951-11.6M81.416,8.4l-.013,0c0,.033.013,0,.013,0",
    transform: "translate(-45.015 0)",
    fill: "#0f0e0b",
    fillRule: "evenodd"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5268",
    "data-name": "Group 5268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5267",
    "data-name": "Group 5267",
    clipPath: "url(#clip-path-bdouin-logo)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8932",
    "data-name": "Path 8932",
    d: "M144.368,191.575a1.842,1.842,0,0,0-2.381,1.057l-3.707,9.628a1.842,1.842,0,1,0,3.438,1.324l3.707-9.628a1.842,1.842,0,0,0-1.057-2.381",
    transform: "translate(-109.979 -152.404)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5270",
    "data-name": "Group 5270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5269",
    "data-name": "Group 5269",
    clipPath: "url(#clip-path-bdouin-logo)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8933",
    "data-name": "Path 8933",
    d: "M227.276,221.068a2.1,2.1,0,0,0-2.626,1.008l-3.707,9.628a2.034,2.034,0,0,0,1.3,2.43,1.842,1.842,0,0,0,2.381-1.057l3.707-9.628a1.842,1.842,0,0,0-1.057-2.381",
    transform: "translate(-175.804 -175.877)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5272",
    "data-name": "Group 5272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5271",
    "data-name": "Group 5271",
    clipPath: "url(#clip-path-bdouin-logo)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8934",
    "data-name": "Path 8934",
    d: "M292.195,188.657a1.267,1.267,0,0,0-1.64.731L288,196.042a1.269,1.269,0,1,0,2.368.915l2.553-6.655a1.275,1.275,0,0,0-.728-1.646",
    transform: "translate(-229.196 -150.112)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5274",
    "data-name": "Group 5274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5273",
    "data-name": "Group 5273",
    clipPath: "url(#clip-path-bdouin-logo)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8935",
    "data-name": "Path 8935",
    d: "M323.875,208.577a1.267,1.267,0,0,0-1.64.731l-2.553,6.655a1.269,1.269,0,1,0,2.368.915l2.553-6.655a1.275,1.275,0,0,0-.728-1.646",
    transform: "translate(-254.415 -165.969)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5276",
    "data-name": "Group 5276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5275",
    "data-name": "Group 5275",
    clipPath: "url(#clip-path-bdouin-logo)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8936",
    "data-name": "Path 8936",
    d: "M99.825,191.769a1.159,1.159,0,0,0-1.5.665l-2.332,6.053a1.159,1.159,0,0,0,2.163.832l2.332-6.053a1.158,1.158,0,0,0-.665-1.5",
    transform: "translate(-76.355 -152.595)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdouinLogo);
export default __webpack_public_path__ + "static/media/bdouin-logo.b68997e0.svg";
export { ForwardRef as ReactComponent };